import React from 'react';
import { Box, Typography } from '@mui/material';
import blueRectangle from '../../assets/ui/blue-rectangle.svg';
import greenRectangle from '../../assets/ui/green-rectangle.svg';

const BalanceCard = ({ 
  title, 
  amount, 
  color = 'blue', // 'blue' or 'green'
}) => {
  const isBlue = color === 'blue';
  const rectangleIcon = isBlue ? blueRectangle : greenRectangle;
  const amountColor = isBlue ? '#027BC6' : '#0AD69F';

  // Parse amount string to separate number and currency
  const parseAmount = (amountStr) => {
    const parts = amountStr.trim().split(/\s+/);
    const currency = parts.length > 1 ? parts[parts.length - 1] : '';
    const number = parts.length > 1 
      ? parts.slice(0, -1).join(' ') 
      : amountStr;
    return { number, currency };
  };

  const { number, currency } = parseAmount(amount);

  return (
    <Box
      style={{
        position: 'relative',
        width: '100%',
        height: '159px',
        backgroundColor: '#FFFFFF',
        backgroundImage: `url('img/Rectangle 17964.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0% 0%',
        backgroundSize: 'cover',
        boxShadow: '0px 8px 32px rgba(98,107,125,0.25)',
        borderRadius: '12px',
        opacity: 1,
        display: 'flex',
        alignItems: 'center',
        padding: '20px'
      }}
    >
      {/* Side Rectangle */}
      <Box
        style={{
          position: 'absolute',
          left: 0,
          top: '60%',
          transform: 'translateY(-50%)',
          width: '8px',
          height: '180%',
          backgroundImage: `url(${rectangleIcon})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          borderRadius: '12px 0 0 12px'
        }}
      />
      
      {/* Content */}
      <Box style={{ marginLeft: '20px', flex: 1, minWidth: 0, overflow: 'hidden', paddingRight: '4px' }}>
        {/* Title */}
        <Typography
          style={{
            fontFamily: 'Montserrat',
            fontWeight: 500,
            fontSize: '20px',
            lineHeight: '24px',
            letterSpacing: '0px',
            color: '#000000',
            textTransform: 'none',
            opacity: 0.88,
            margin: 0,
            marginBottom: '12px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%'
          }}
        >
          {title}
        </Typography>
        
        {/* Amount Container - allows flex wrapping */}
        <Box
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'baseline',
            columnGap: '14px',
            rowGap: '1px',
            maxWidth: '100%',
            overflow: 'hidden'
          }}
        >
          {/* Number part */}
          <Typography
            style={{
              fontFamily: 'Montserrat',
              fontWeight: 700,
              fontSize: 'clamp(26px, 4.5vw, 67px)',
              lineHeight: 0.95,
              letterSpacing: '0px',
              color: amountColor,
              textTransform: 'none',
              opacity: 0.88,
              margin: 0,
              padding: 0,
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              flexShrink: 1,
              minWidth: 0,
              maxWidth: '100%'
            }}
          >
            {number}
          </Typography>
          
          {/* Currency part - wraps to next line if needed */}
          {currency && (
            <Typography
              style={{
                fontFamily: 'Montserrat',
                fontWeight: 700,
                fontSize: 'clamp(26px, 4.5vw, 67px)',
                lineHeight: 0.95,
                letterSpacing: '0px',
                color: amountColor,
                textTransform: 'none',
                opacity: 0.88,
                margin: 0,
                padding: 0,
                whiteSpace: 'nowrap',
                flexShrink: 0
              }}
            >
              {currency}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default BalanceCard;
